const STEPS = [
  'Reads the brand and size you already know.',
  'Maps that brand and size to its published garment measurements.',
  'Compares those measurements against every other verified brand, region by region (chest, waist, hip, and more depending on the garment).',
  'Recommends the size with measurements closest to yours.',
  'Shows which areas are likely to run tight, comfortable, or loose — based on the actual measurement differences, not a guess.',
];

interface Props {
  onClose: () => void;
}

export function HowItWorksModal({ onClose }: Props) {
  return (
    <div className="fixed inset-0 z-30 flex items-center justify-center bg-ink/40 p-4" role="presentation" onClick={onClose}>
      <div
        role="dialog"
        aria-modal="true"
        aria-label="How FitMap works"
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-md rounded-2xl bg-white p-5 shadow-card"
      >
        <div className="mb-3 flex items-start justify-between gap-3">
          <p className="text-lg font-bold text-ink">How FitMap works</p>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="min-h-[36px] min-w-[36px] rounded-full border border-stone-200 text-muted hover:text-ink"
          >
            ✕
          </button>
        </div>
        <ol className="space-y-2.5 text-sm text-ink/80">
          {STEPS.map((step, i) => (
            <li key={step} className="flex gap-2.5">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-ink text-[11px] font-bold text-white">
                {i + 1}
              </span>
              <span>{step}</span>
            </li>
          ))}
        </ol>
        <p className="mt-4 text-xs text-muted">
          It's a transparent, deterministic scoring formula over published measurements — not AI or machine learning, and nothing hidden.
        </p>
      </div>
    </div>
  );
}
